import React, { useContext, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { AppContext } from '../../contexts';
import styles from './styles.scoped.css';

export default function Error403() {
  const { setBreadcrumbs } = useContext(AppContext);
  useEffect(() => {
    setBreadcrumbs(['403']);
  }, []);

  return (
    <section>
      <h4>Fitur ini tidak dapat digunakan</h4>
      <Link className={styles.btn} to="/" type="primary">Kembali ke Beranda</Link>
    </section>
  );
}
